import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";

const buildPayload = (params) => ({
  code:  params.get("code")  || "",
  state: params.get("state") || "",
});

const MetaAdsCallback = () => (
  <OAuthCallbackShell
    platform="Meta Ads"
    endpoint="/api/ads-auth/meta/callback"
    buildPayload={buildPayload}
  />
);

export default MetaAdsCallback;
